var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.467,
    height: 18.502,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-phone",
    d: "M17.717 13.478v2.559a1.706 1.706 0 0 1-1.86 1.706 16.882 16.882 0 0 1-7.362-2.619 16.635 16.635 0 0 1-5.118-5.118 16.882 16.882 0 0 1-2.619-7.4A1.706 1.706 0 0 1 2.455.75h2.56a1.706 1.706 0 0 1 1.706 1.467 10.953 10.953 0 0 0 .6 2.4 1.706 1.706 0 0 1-.384 1.8L5.851 7.498a13.649 13.649 0 0 0 5.118 5.118l1.083-1.083a1.706 1.706 0 0 1 1.8-.384 10.953 10.953 0 0 0 2.4.6 1.706 1.706 0 0 1 1.467 1.732Z",
    fill: "none",
    stroke: "#5e708d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPhone);
export default __webpack_public_path__ + "static/media/feather-phone.ed8af2ab582d697f910bb156536e4bf1.svg";
export { ForwardRef as ReactComponent };